import { render, staticRenderFns } from "./TagComplementoServico.vue?vue&type=template&id=3a500f06&"
import script from "./TagComplementoServico.vue?vue&type=script&lang=js&"
export * from "./TagComplementoServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports